<template>
  <div>
    <div class="pt-4 fixed z-50 inset-0 w-full h-screen px-4 py-8 bg-gray-50">
      <div class="text-xxs text-nw-ash" v-if="delivering.location != ''">Search Delivery location*</div>
      <div class="relative">
        <input
          type="text"
          v-model="delivery_location"
          placeholder="Search Delivery location*"
          class="rounded-lg pl-12 pr-6 py-4 shadow-lg text-xs w-full focus:outline-none"
        />
        <div class="absolute top-2 left-4 mt-px" @click="closePop">
          <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
        </div>
      </div>
      <div>
        <div
          class="border-b w-full px-6 py-4 text-xxs"
          v-for="(location, index) in delivery_location_search"
          :key="index"
          :class="{ 'pb-4': index != delivery_location_search.length - 1 }"
        >
          <div @click="selectDelivery(index)">
            {{ location.formatted_address }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackArrowIcon from '../icons/BackArrowIcon.vue'
export default {
  components: { BackArrowIcon },
  data() {
    return {
      delivering: {
        location: '',
        coordinates: { lat: '', lng: '' },
        region_details: ''
      },
      delivery_location: '',
      delivery_location_search: []
    }
  },
  watch: {
    delivery_location(val) {
      if (val != '') {
        this.delivering.location = val
        this.close_pickup_list = false
        this.getDeliverySearch(val)
      } else {
        this.delivery_location_search = []
      }
    },
    pick: {
      deep: true,
      handler(val) {
        if (val.region_details != '') {
          var payload = {
            delivering: val,
            delivery_location: this.delivery_location
          }
          this.$emit('delivery-location', payload)
        }
      }
    }
  },
  methods: {
    closePop() {
      this.$emit('open-deliverypop', false)
    },
    selectDelivery(index) {
      this.delivering.coordinates.lat = this.delivery_location_search[index].geometry.location.lat()
      this.delivering.coordinates.lng = this.delivery_location_search[index].geometry.location.lng()
      this.delivery_location = this.delivery_location_search[index].formatted_address
      this.delivery_location_search = []
      this.delivering.region_details = this.getClosestDistance(this.delivering.coordinates)[0]
      var payload = {
        delivering: this.delivering,
        delivery_location: this.delivery_location
      }
      this.$emit('delivery-location', payload)
      this.closePop()
    },
    async getDeliverySearch(place) {
      // const request = {
      //   query: place,
      //   fields: ['formatted_address', 'name', 'geometry']
      // }
      // // eslint-disable-next-line no-undef
      // var service = new google.maps.places.PlacesService(document.getElementById('map'))
      // service.findPlaceFromQuery(request, (results, status) => {
      //   // eslint-disable-next-line no-undef
      //   if (status === google.maps.places.PlacesServiceStatus.OK && results) {
      //     this.delivery_location_search = results
      //   }
      // })

      try {
        // eslint-disable-next-line no-undef
        const { Place } = await google.maps.importLibrary('places')

        const { places } = await Place.searchByText({
          textQuery: place,
          fields: ['displayName', 'formattedAddress', 'location']
        })

        this.delivery_location_search = (places || []).map(p => ({
          name: p.displayName,
          formatted_address: p.formattedAddress,
          geometry: {
            location: p.location
          },
          place_id: p.id
        }))
      } catch (error) {
        console.error('Place search failed:', error)
        this.delivery_location_search = []
      }
    },
    getClosestDistance(val) {
      return this.$store.getters['arrange_details/getClosestDistance'](val)
    }
  }
}
</script>

<style></style>
